import {
    type QueryHookOptions,
    type TypedDocumentNode,
    useQuery,
} from '@apollo/client';
import { useMemo } from 'react';
import { type QueryConnection } from './models/QueryConnection';
import { getNodes } from './utils';

export function useQueryConnection<
    Payload extends Record<string, any>,
    Response,
>(
    query: TypedDocumentNode<Response, Payload>,
    variables: Payload = {} as Payload,
    options: QueryHookOptions<Response, Payload> = {},
): QueryConnection<Payload, Response> {
    const { data, loading, error, refetch } = useQuery(query, {
        ...options,
        variables,
    });

    const nodes = useMemo(() => getNodes(data), [data]);

    return { nodes, loading, error, refetch, raw: data };
}
